export enum OccupancyRentalMenuEnum {
    overview = 0,
    residentialUnitsGradeWise,
    residentialUnitsTypeWise,
    commercialUnitsGradeWise,
    commercialUnitsSizeWise,
    unitRentalTransaction,
    unit,
    unitTransaction
}